module.exports = __webpack_public_path__ + "static/media/snow_hi.fcaa044f.svg";